import { render, staticRenderFns } from "./AccordionListDefault.vue?vue&type=template&id=2f74b8c7&"
import script from "./AccordionListDefault.vue?vue&type=script&lang=js&"
export * from "./AccordionListDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports